var _defs, _path, _polygon, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailbox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 398 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dddfe4;}.b{opacity:0.15;isolation:isolate;}.c{fill:#b93be4;}.d{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M285.42,235.41,101.06,222.06a2.13,2.13,0,0,1-2-2.24l9.17-110.91a2.19,2.19,0,0,1,2.4-1.92l184.36,13.35a2.13,2.13,0,0,1,2.05,2.24l-9.17,110.91A2.19,2.19,0,0,1,285.42,235.41Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "294.94 120.34 195.63 199.88 110.58 106.99 294.94 120.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M110.58,107,208.2,28.8a2.34,2.34,0,0,1,3.14.23l83.6,91.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M150.26,214.94l-33.61-2.6a1.57,1.57,0,0,1,.24-3.14h0l33.61,2.6a1.57,1.57,0,0,1-.24,3.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M129.23,206.52l-12.06-.93a1.58,1.58,0,0,1,.24-3.15h0l12.06.94a1.57,1.57,0,1,1-.24,3.14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M156.24,46.56l-27,80.9,66.31,72.42,74-59.2,18.55-55.6a2.05,2.05,0,0,0-1.46-2.61L159,45.19A2.27,2.27,0,0,0,156.24,46.56Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M168.9,117.33a3.91,3.91,0,0,1,.77-5.47l6.25-4.69a3.9,3.9,0,0,1,5.47.77l14.54,19.33,41.4-31.15a3.91,3.91,0,0,1,5.47.78l4.7,6.24a3.91,3.91,0,0,1-.78,5.47L196,146.8a3.91,3.91,0,0,1-5.47-.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.36362e87c9e8dd027ff6dbfef4df5014.svg";
export { ForwardRef as ReactComponent };